import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Alert, Box, Typography} from '@mui/material';
import {compose} from "redux";
import {connect} from "react-redux";
import {useFlashMessageAck} from "../../../hooks/useFlashMessages";
import {toast} from "react-toastify";
import {MuiButton} from "../../MuiButton";

const AlertFlashMessage = ({flashMessage, i18n, t}) => {
    const [open, setOpen] = React.useState(true);
    const { data, mutateAsync, status, error } = useFlashMessageAck(i18n.language);
    const handleClose = (flashMessageId) => {
        try {
            setOpen(false);
            mutateAsync(flashMessageId).then(r => {

            });

        } catch (e) {
            console.error(e);
            toast.error(t('common.error.save'));
            setOpen(true);
        }
    };

    useEffect(() => {
        setOpen(true);
    }, [flashMessage]);


    return <>
            {flashMessage.severity && <Alert
                severity={flashMessage.severity}
                style={{marginTop: "15px", marginBottom: "15px"}}
            >
                <Typography variant="h3" gutterBottom dangerouslySetInnerHTML={{__html: flashMessage.label}}/>

                <p className="wysiwyg" dangerouslySetInnerHTML={{__html: flashMessage.content}}/>
                {flashMessage.discardable && <div>
                    <MuiButton onClick={() => handleClose(flashMessage.id)}
                               variant="contained"
                               color="primary">
                        {t("FlashMessage.confirm")}
                    </MuiButton>
                </div>}

    {/*<Typography variant="body1" class="wysiwyg" gutterBottom dangerouslySetInnerHTML={{__html:flashMessage.content}}/>*/}
            </Alert>}
        {!flashMessage.severity && <>
            <Typography variant="h3" gutterBottom dangerouslySetInnerHTML={{__html: flashMessage.label}}/>
            <p className="wysiwyg" dangerouslySetInnerHTML={{__html: flashMessage.content}}/>

            <Box display="flex" alignItems="flex-start">
                <Box flexGrow={1}>
                </Box>
                {flashMessage.discardable && <Box>
                    <MuiButton onClick={() => handleClose(flashMessage.id)}
                               variant="contained"
                               color="primary">
                        {t("FlashMessage.confirm")}
                    </MuiButton>
                </Box>}
            </Box>
        </>}
    </>;
};

const mapStateToProps = (state) => {
    return {}
};

export default compose(
    withTranslation(),
    connect(
        mapStateToProps
    ))(AlertFlashMessage);
